const VRP_EMAIL_DOMAINS = ['@finalytic.co', '@vrplatform.app'];
const VRP_EMAILS = [
  'radek+vrp@setup.inc',
  'philipp@philipp-achenbach.de',
  'l.behrenberg@gmail.com',
  'l.behrenberg+secondary@gmail.com',
  'adam@ximplifi.com',
];
const VRP_USER_IDS = [
  '3267f329-26d9-471d-86c1-d4c2efab2951',
  '735e1803-13f5-4a90-a02f-2498b3eefa03',
  '1a2bd1ea-88b1-4217-935f-2a8d97c422f9',
  '4b221539-d6cf-4d18-a015-1f3a99fc3c2d',
  '5e9bdcc1-71ae-4e59-87a1-affbfc3ce603',
  '2a40c6c5-c9a2-4d98-a70f-3c6f75bff3e2',
  '31a87570-3917-4e4c-b237-af605ab0094b',
  'ec78e603-705c-4f1c-9b85-4dc5733c5b85',
  '16b5bd68-8261-4192-a28a-13817b31fede',
  '2e22dcba-73f0-4699-bc48-088209804fe2',
  '840da880-9a3d-43e5-9e2e-d4c74429ed17',
  '9ecc0316-e7dc-4c73-960d-01c2763fb8da',
  '9f6008c7-4df5-4aec-997f-07ecd44a2f79',
  '27dc0d2a-d11a-4fe1-a500-6e0e6350ad04',
];

export const isVrpMember = ({
  email,
  userId,
}: {
  email?: string | null;
  userId?: string | null;
}) =>
  Boolean(
    (email &&
      (VRP_EMAILS.includes(email) ||
        VRP_EMAIL_DOMAINS.some((domain) => email.endsWith(domain)))) ||
    (userId && VRP_USER_IDS.includes(userId))
  );
